import { MenuPositionX, MenuPositionY } from '@angular/material/menu';
import { Observable } from 'rxjs';

export interface IEditImageToolSettings {
  actionMode: 'button' | 'contextmenu';
  label: string;
  displayIcon: boolean;
  displayCorner: boolean;
  displayHotKey: boolean;
  disableTooltip: boolean;
  openMenu?: boolean;
  openMenuByContext?: boolean;
  closeMenuCondition$?: Observable<boolean>;
  menuClass?: string;
  menuItemClass?: string;
  hideMenuBackdrop?: boolean;
  menuPosition: {
    x: MenuPositionX;
    y: MenuPositionY;
  };
}
